import React, { useContext, useEffect, useState } from "react";
import { filtrationcontext } from "../../../context/Filtercontext";
import { useGetAllformsQuery } from "../../../Redux/service/Forms/Form";
import trans from "../../../utils";
import AntdTable from "../../antd/Table/Table";
import Loader from "../../Helpers/Loader/Loader";
import { Helmet } from "react-helmet";
import FormsHead from "./FormsHead/FormsHead";
import Actions from "../../antd/Table/Actions";
import BreadCrumb from "../../Header/SecondHeader";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { capitalize } from "lodash";
import usePermission from "../../../hooks/usePermission";

export default function Forms() {
	const [currentPage, setCurrentPage] = useState(1);
	const { create, view, edit, delete: canDelete } = usePermission("FORMS");

	const navigate = useNavigate();
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const {
		handleShow,
		setEdited,
		reloadData,
		setReloadData,
		deleteItem,
		setDeleteItem,
	} = useContext(popupcontext);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});
	let {
		data: AllForms,
		isLoading,
		isError,
		refetch,
	} = useGetAllformsQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
			isActive: "true",
		},
		{
			skip: !currentPage || !limit,
			refetchOnMountOrArgChange: true,
		},
	);
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setCurrentPage(1);
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);
	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);
	useEffect(() => {
		if (reloadData) {
			refetch();
		}
		setReloadData(false);
	}, [reloadData]);
	useEffect(() => {
		async function fetchdata() {
			if (deleteItem.condition === true && deleteItem.value === "form") {
				await refetch();
				setDeleteItem({ condition: null, value: null });
			}
		}
		fetchdata();
	}, [deleteItem.condition, deleteItem.value, refetch, setDeleteItem]);
	if (isError)
		return toast.error(trans("Please try again"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});

	const fieldMapping = {
		createdBy: "creatorName",
	};
	const formsColumns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			sorter: true,
			fixed: "left",
			key: "name",
			render: (name) => <span className="text-primary">{name}</span>,
		},
		{
			title: trans("Code"),
			dataIndex: "code",
			sorter: true,
			fixed: "left",
			key: "code",
			render: (code) => <span>{code || "- - - - - -"}</span>,
		},
		{
			title: trans("Description"),
			dataIndex: "description",
			key: "description",
			width: 200,
			render: (description = "") => {
				const trimmed =
					description?.length > 25
						? description.slice(0, 25) + "..."
						: description;

				return <span title={description}>{trimmed || "- - - - - -"}</span>;
			},
		},
		{
			title: trans("created by"),
			dataIndex: "createdBy",
			sorter: { multiple: 1, field: "creatorName" },
			width: 200,
			capitalize: true,
			render: (createdBy) => <span>{createdBy.name}</span>,
		},
		{
			title: trans("created at"),
			dataIndex: "createdAt",
			key: "createdAt",
			capitalize: true,
			sorter: true,
			render: (createdAt) => <span>{formatDateString(createdAt)}</span>,
		},
		{
			title: trans("updated at"),
			dataIndex: "updatedAt",
			key: "updatedAt",
			sorter: true,
			capitalize: true,
			render: (updatedAt) => <span>{formatDateString(updatedAt)}</span>,
		},
		{
			title: trans("Actions"),
			key: "actions",
			render: (_, record) => (
				<Actions
					formId={record.id}
					name={record.name}
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
				/>
			),
		},
	];
	console.log(
		"Create",
		create,
		"Edit",
		edit,
		"View",
		view,
		"Delete",
		canDelete,
	);
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			const apiField = fieldMapping[sorter.field] || sorter.field; // Fallback to sorter.field if no mapping is needed

			setSort({
				by: apiField,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};
	return (
		<div className="users">
			<Helmet>
				<title>Forms</title>
				<meta name="description" content="Forms" />
			</Helmet>
			<BreadCrumb
				title={trans("forms")}
				add={create ? trans("Add new form") : null}
				onClick={() => navigate("/forms/formbuilder")}
			/>
			<FormsHead />
			{isLoading ? (
				<>
					<div className="loader-container loader-table">
						<Loader />
					</div>
				</>
			) : (
				<>
					<div className="bg-white-rounded-top mt-3 table-parent">
						<AntdTable
							columns={formsColumns}
							dataSource={AllForms?.data?.filter((form) => form.isActive) || []}
							loading={isLoading}
							pageSize={limit}
							totalItems={AllForms?.totalResults || 0} // Total count for pagination
							currentPage={currentPage}
							onPageChange={(page) => setCurrentPage(page)}
							onLimitChange={(newLimit) => {
								setLimit(newLimit);
								setCurrentPage(1);
							}}
							onTableChange={handleTableChange}
						/>
					</div>
				</>
			)}
		</div>
	);
}
